import { FC, PropsWithChildren } from 'react'

export type AccessibilityNavProps = PropsWithChildren

export const AccessibilityNav: FC<AccessibilityNavProps> = ({ children }) => {
    return <ul className="c-accessibility-nav">{children}</ul>
}
